import { createStyles } from "@mantine/core";

const useLoginStyles = createStyles((theme) => ({
  root: {
    minHeight: "100vh",
    display: "flex",
    backgroundColor: "#f9fafb",
    fontFamily: "system-ui, -apple-system, sans-serif",
  },
  brandPanel: {
    flex: "1 1 50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "64px",
    color: "#fff",
    background: "linear-gradient(135deg, #1e1b4b 0%, #4338ca 100%)",
    position: "relative",
    overflow: "hidden",
    [theme.fn.smallerThan("md")]: {
      display: "none",
    },
  },
  brandLogo: {
    height: "48px",
    marginBottom: "24px",
    display: "block",
  },
  brandTitle: {
    fontSize: "48px",
    fontWeight: 800,
    lineHeight: 1.1,
    marginBottom: "16px",
    margin: 0,
  },
  brandSubtitle: {
    fontSize: "18px",
    lineHeight: 1.6,
    color: "rgba(255,255,255,0.8)",
    maxWidth: "420px",
    margin: "16px 0 0 0",
  },
  formPanel: {
    flex: "1 1 50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
    [theme.fn.smallerThan("md")]: {
      flex: "1 1 100%",
    },
  },
  formCard: {
    width: "100%",
    maxWidth: "400px",
    padding: "40px",
    borderRadius: "16px",
    backgroundColor: "#fff",
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.05)",
  },
  heading: {
    fontSize: "24px",
    fontWeight: 700,
    color: "#111827",
    margin: "0 0 8px 0",
  },
  subheading: {
    color: "#6b7280",
    fontSize: "14px",
    margin: "0 0 28px 0",
  },
  formGroup: {
    marginBottom: "20px",
  },
  label: {
    display: "block",
    fontSize: "14px",
    fontWeight: 600,
    color: "#374151",
    marginBottom: "8px",
  },
  input: {
    width: "100%",
    height: "42px",
    padding: "0 14px",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    backgroundColor: "#fff",
    fontSize: "14px",
    color: "#111827",
    boxSizing: "border-box",
    transition: "border-color 0.2s, box-shadow 0.2s",
    "&:focus": {
      outline: "none",
      borderColor: "#4f46e5",
      boxShadow: "0 0 0 3px rgba(79, 70, 229, 0.1)",
    },
  },
  passwordWrapper: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  passwordToggle: {
    position: "absolute",
    right: "12px",
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "#6b7280",
    display: "flex",
    padding: 0,
    "&:hover": {
      color: "#374151",
    },
  },
  select: {
    width: "100%",
    height: "42px",
    padding: "0 14px",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    backgroundColor: "#fff",
    fontSize: "14px",
    color: "#111827",
    boxSizing: "border-box",
    cursor: "pointer",
    appearance: "none",
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%236b7280'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 12px center",
    backgroundSize: "16px",
    "&:focus": {
      outline: "none",
      borderColor: "#4f46e5",
      boxShadow: "0 0 0 3px rgba(79, 70, 229, 0.1)",
    },
  },
  errorBox: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    marginTop: "12px",
    padding: "10px 12px",
    borderRadius: "8px",
    backgroundColor: "#fef2f2",
    border: "1px solid #fecaca",
    color: "#b91c1c",
    fontSize: "13px",
  },
  submitButton: {
    width: "100%",
    height: "42px",
    borderRadius: "8px",
    border: "none",
    fontWeight: 600,
    fontSize: "14px",
    color: "#fff",
    background: "#4f46e5",
    cursor: "pointer",
    transition: "background 0.2s",
    marginTop: "8px",
    "&:hover": {
      background: "#4338ca",
    },
    "&:disabled": {
      opacity: 0.7,
      cursor: "not-allowed",
    },
  },
  modeSwitch: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 8,
    marginBottom: 20,
    padding: 4,
    borderRadius: 10,
    background: "#f3f4f6",
  },
  modeBtn: {
    border: "none",
    background: "transparent",
    borderRadius: 8,
    height: 36,
    fontWeight: 700,
    fontSize: 13,
    color: "#6b7280",
    cursor: "pointer",
  },
  modeBtnActive: {
    background: "#fff",
    color: "#111827",
    boxShadow: "0 1px 4px rgba(15, 23, 42, 0.08)",
  },
}));

export default useLoginStyles;
